import React, { useEffect, useState } from 'react'
// import Stepper from './Stepper'
import { connect } from 'react-redux'
import { certapplyActions } from '../../../../../store/actions'

import Input from '../../../../../module/input'
import Zip from '../../../../../module/zip'
import { regConstants } from '../../../../../store/constants'
import history from '../../../../../route/history'
import Certapply from './Certapply'
import { valid } from '../../../../../hook/valid'
import * as common from '../../../../../assets/js/common.js'
import { commons } from '../../../../../hook/common'

/**
 * 구매확인서 1단계 / 일반정보 입력
 * @desc  !! 공급물품 용도명세라는 항목은 4월에 추가하는 것으로 협의(AB)
 */
const Step01 = (props) => {
  const nodeBaseInfo = {
    docid: {
      title: '전자문서번호',
      type: 'text',
      length: 35,
      readOnly: true,
      required: true,
      className: 'full',
    },
    issueNm: {
      title: '수신처(발급기관)',
      type: 'text',
      length: 100,
      required: true,
      message: '수신처를 입력해주세요.',
      className: 'full',
    },
    bfmdfcnfrmprch: {
      title: '변경전 구매확인서번호',
      type: 'text',
      length: 40,
      className: 'full',
    },
    /********* 신청인 **********/
    lctorgnm: {
      title: '상호',
      type: 'text',
      length: 35,
      required: true,
      readOnly: true,
      className: 'full',
    },
    lctceonm: {
      title: '성명',
      type: 'text',
      length: 35,
      required: true,
      message: '신청인 성명을 입력해주세요.',
      className: 'full',
    },
    lctprtid: {
      title: '사업자등록번호',
      type: 'number',
      length: 10,
      required: true,
      readOnly: true,
      className: 'full',
    },
    lctaddr1: {
      title: '주소',
      type: 'text',
      inputTitle: '우편번호',
      required: true,
      readOnly: true,
      message: '우편번호, 주소를 입력해주세요.',
      className: 'col1',
    },
    lctaddr2: {
      type: 'text',
      inputTitle: '주소',
      required: true,
      readOnly: true,
      placeholder: '주소',
      className: 'col2',
    },
    lctaddr3: {
      type: 'text',
      inputTitle: '상세주소',
      placeholder: '상세주소',
      length: 35,
      className: 'full',
    },
    /********* 공급자 **********/
    splyCmpyNm: {
      title: '상호',
      type: 'text',
      length: 35,
      required: true,
      message: '공급자 상호를 입력해주세요.',
      className: 'full',
    },
    splynm: {
      title: '성명',
      type: 'text',
      length: 35,
      required: true,
      message: '공급자 성명을 입력해주세요.',
      className: 'full',
    },
    splyprtnum: {
      title: '사업자등록번호',
      type: 'number',
      length: 10,
      required: true,
      placeholder: "('-')없이 숫자만 입력",
      message: '공급자 사업자등록번호를 입력해주세요.',
      className: 'full',
    },
    splyaddr1: {
      title: '주소',
      type: 'text',
      inputTitle: '우편번호',
      required: true,
      readOnly: true,
      message: '우편번호, 주소를 입력해주세요.',
      className: 'col1',
    },
    splyaddr2: {
      type: 'text',
      required: true,
      readOnly: true,
      inputTitle: '주소',
      placeholder: '주소',
      className: 'col2',
    },
    splyaddr3: {
      type: 'text',
      inputTitle: '상세주소',
      placeholder: '상세주소',
      length: 35,
      className: 'full',
    },
    /********* 공급자에게 전자문서를 전달하는경우 **********/
    splycd: {
      title: '수발신인식별자',
      type: 'text',
      length: 35,
      className: 'full',
    },
    splyid: {
      title: '상세수발신인식별자',
      type: 'text',
      length: 35,
      className: 'full',
    },
    /********* 공급자에게 발급사실을 통지하는 경우 **********/
    emlAddr: {
      title: '이메일주소',
      type: 'text',
      length: 70,
      regex: regConstants.email,
      regErrMsg: '이메일 주소 형식이 아닙니다.',
      className: 'full',
    },
  }

  const [showCertapply, setShowCertapply] = useState(false)
  const [nodeInfo, setNodeInfo] = useState(nodeBaseInfo)
  const inputRef = React.useRef(new Array(Object.keys(nodeBaseInfo).length))
  //console.log('inputRef = ', inputRef);
  const [state, setState] = useState({
    isLctZipOpen: false,
    isSplyZipOpen: false,
    lctaddr1: '',
    lctaddr2: '',
    lctaddr3: '',
    splyaddr1: '',
    splyaddr2: '',
    splyaddr3: '',
  })

  /**
   * 화면 진입시 초기값 설정
   */
  useEffect(() => {
    const value = props.search?.split('=')[1]
    let key = props.search?.split('=')[0]
    commons.preventKeyDown()
    if (!value && !key) {
      //신규작성
      setShowCertapply(true)
    } else if (key === '?id' && value) {
      //문서번호 발급이후
      setShowCertapply(false)
      let docInfo = JSON.parse(sessionStorage.getItem(value))?.step1
      if (!docInfo) {
        window.location.replace('/service/certapply/1')
      } else {
        docInfo.issueNm = 'EKTNET'
        setState(docInfo)
      }
    }
  }, [])

  /**
   * 임시저장 호출 후 콜백
   */
  useEffect(() => {
    if (props.isCalled === true) {
      if (props.packageId === 0) {
        let docInfo = JSON.parse(sessionStorage.getItem(props.totalData?.step1?.docid))

        if (props.totalData?.step1?.docid) {
          docInfo.step1 = props.stepData
          sessionStorage.setItem(props.totalData?.step1?.docid, JSON.stringify(docInfo))
          history.push('/service/certapply/2?id=' + props.totalData?.step1?.docid)
        }
      }
      if (props.packageId > 0) {
        props.onload(props.totalData?.step1?.crtIssueSeq, 2)
      }
    }

    props.setCalled(false)
  }, [props.isCalled])

  const handleChange = (e) => {
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value,
    })
  }

  /**
   * 다음화면 진입을 위한 유효성 체크
   */
  const goStepNext = () => {
    setState({ ...state, submitted: !state.submitted })

    let node = nodeInfo
    let errCnt = 0
    let isFocus = false

    Object.keys(node).forEach((key, index) => {
      let message = null

      //필수 체크
      if (node[key].required) {
        // key === 'lctaddr1' && console.log('lctaddr1', node[key], state?.[key])
        // key === 'splyaddr1' && console.log('splyaddr1', node[key], state?.[key])
        // if (!state?.[key] || state?.[key]?.length <= 0) {
        if (state?.[key] === 'null' || !state?.[key] || state?.[key]?.length <= 0) {
          message = node[key]?.message
          errCnt++
        }
      }

      //유효성 체크
      if (message === null && state?.[key]?.length > 0 && !!node[key].regex) {
        let regex = node[key].regex
        let value = state?.[key]
        let regResult = regex.test(value)

        if (!regResult) {
          message = node[key]?.regErrMsg
          errCnt++
        } else {
          message = null
        }
      }

      //사업자번호
      if (key === 'lctprtid') {
        if (!valid.checkbizNo(state.lctprtid)) {
          message = '유효한 사업자번호가 아닙니다.'
          errCnt++
        }
      }
      //사업자번호
      if (key === 'splyprtnum') {
        if (!valid.checkbizNo(state.splyprtnum)) {
          message = '유효한 사업자번호가 아닙니다.'
          errCnt++
        }
      }

      node[key].errMessage = message

      if (!isFocus && errCnt === 1) {
        isFocus = true
        inputRef.current[index] === undefined && document.getElementById(key).focus()

        if (inputRef.current[index]) {
          inputRef.current[index].focus()
        }
      }
    })

    if (errCnt > 0) return

    setState({ ...state, isCall: true })
    props.saveStep1(state)
  }

  const generateRow = (key) => {
    const node = nodeInfo[key]
    let idx = Object.keys(nodeBaseInfo).findIndex((objKey) => objKey === key)
    let className = 'form-keyword '
    let wrapperClassName = node?.wrapperClassName

    return (
      <Input
        id={key}
        name={key}
        type={node.type}
        value={state?.[key] === 'null' ? '' : state?.[key] || ''}
        inputTitle={node?.inputTitle ? node?.inputTitle : node?.title}
        ref={(ref) => (inputRef.current[idx] = ref)}
        wrapperClassName={wrapperClassName}
        className={className + node?.className}
        placeholder={node?.placeholder}
        message={node?.message}
        onChange={handleChange}
        readOnly={node.readOnly}
        required={node.required}
        flow={node.flow ? node.flow : `${window.innerWidth >= 767 ? 'left' : 'up'}`}
        length={node.length}
        errMessage={node.errMessage}
      />
    )
  }

  /**
   * 우편번호 콜백
   * @param info
   */
  const setLctAddress = (info) => {
    setState({
      ...state,
      lctaddr1: info?.zipNo,
      lctaddr2: info?.roadAddr,
      lctaddr3: '',
      isLctZipOpen: false,
    })
    //console.log('setState1 = ', state)
  }

  const setSplyAddress = (info) => {
    setState({
      ...state,
      splyaddr1: info?.zipNo,
      splyaddr2: info?.roadAddr,
      splyaddr3: '',
      isSplyZipOpen: false,
    })
    //console.log("setState2 = ", state);
  }

  const reload = (crtIssueSeq) => {
    setShowCertapply(false)
    props.onload(crtIssueSeq, 1)
    if (props.packageId > 0) {
      //console.log('props.totalData = ', props.totalData);
      let docInfo = props.totalData?.step1
      docInfo.issueNm = 'EKTNET'
      // 꾸러미 신청 시 초기화
      docInfo.splyCmpyNm = ''
      docInfo.splynm = ''
      docInfo.splyprtnum = ''
      docInfo.splyaddr1 = ''
      docInfo.splyaddr2 = ''
      docInfo.splyaddr3 = ''
      
      setState(docInfo)
    }
  }

  return (
    <React.Fragment>
      {showCertapply && <Certapply packageId={props.packageId} packageCrtfNo={props.packageCrtfNo} onSelect={reload} />}

      <h3 className="h3-tit mt30">정보</h3>
      <p className="required">* 표시는 필수 입력사항입니다.</p>
      <table className="tbl-write">
        <caption>전자문서번호, 수신처(발급기관) 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">
              <em className="required" /> 전자문서번호
            </th>
            <td>
              {generateRow('docid')} {/* 전자문서번호 */}
            </td>
          </tr>
          <tr>
            <th scope="row">
              <em className="required" /> 수신처(발급기관)
            </th>
            <td>
              {generateRow('issueNm')} {/* 수신처 */}
            </td>
          </tr>
        </tbody>
      </table>
      <h3 className="h3-tit">일반정보</h3>
      <h4 className="h4-tit">01. 신청인 정보</h4>
      <p className="required">* 표시는 필수 입력사항입니다.</p>
      <table className="tbl-write">
        <caption>상호, 이름, 사업자등록번호 , 주소, 상세주소 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">
              <em className="required" /> 상호
            </th>
            <td>
              {generateRow('lctorgnm')} {/* 상호 */}
            </td>
          </tr>
          <tr>
            <th scope="row">
              <em className="required" /> 이름
            </th>
            <td>
              {generateRow('lctceonm')} {/* 성명 */}
            </td>
          </tr>
          <tr>
            <th scope="row">
              <em className="required" /> 사업자등록번호
            </th>
            <td>
              {generateRow('lctprtid')} {/* 사업자등록번호 */}
            </td>
          </tr>
          <tr>
            <th scope="row">
              <em className="required" /> 주소
            </th>
            <td>
              <div className="input-wrapper ">
                <div className="" tooltip="우편번호, 주소를 입력해주세요." flow="left" flag="hidden">
                  <span className="inquiry-group full">
                    <input
                      type="text"
                      id="lctaddr1"
                      title="우편번호"
                      name="lctaddr1"
                      className="form-keyword col1"
                      placeholder="우편번호"
                      readOnly
                      value={state?.['lctaddr1'] === 'null' ? '' : state?.['lctaddr1'] || ''}
                    />
                    <a
                      className="btn-secondary sm cursor"
                      onClick={(e) => {
                        e.preventDefault()
                        setState({ ...state, isLctZipOpen: !state.isLctZipOpen })
                        common.getDeviceType() === 'MobileApp' && window.scrollTo(0, 0)
                      }}
                    >
                      주소찾기
                    </a>
                    &nbsp;
                    <input
                      type="text"
                      id="lctaddr2"
                      title="주소"
                      name="lctaddr2"
                      className="form-keyword col2"
                      placeholder="주소"
                      readOnly
                      value={state?.['lctaddr2'] === 'null' ? '' : state?.['lctaddr2'] || ''}
                      style={{ width: 'inherit' }}
                    />
                  </span>
                  {nodeInfo.lctaddr1.errMessage && (
                    <div className="input-error">
                      <label htmlFor={'lctaddr1'} style={{ color: 'red' }}>
                        {nodeInfo.lctaddr1.errMessage}
                      </label>
                    </div>
                  )}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row"> 상세주소</th>
            <td>
              {generateRow('lctaddr3')} {/* 상세주소 */}
            </td>
          </tr>
        </tbody>
      </table>
      <h4 className="h4-tit">02. 공급자 정보</h4>
      <p className="required">* 표시는 필수 입력사항입니다.</p>
      <table className="tbl-write">
        <caption>상호, 이름, 사업자등록번호 , 주소, 상세주소 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">
              <em className="required" /> 상호
            </th>
            <td>
              {generateRow('splyCmpyNm')} {/* 상호 */}
            </td>
          </tr>
          <tr>
            <th scope="row">
              <em className="required" /> 이름
            </th>
            <td>
              {generateRow('splynm')} {/* 성명 */}
            </td>
          </tr>
          <tr>
            <th scope="row">
              <em className="required" /> 사업자등록번호
            </th>
            <td>
              {generateRow('splyprtnum')} {/* 사업자등록번호 */}
            </td>
          </tr>
          <tr>
            <th scope="row">
              <em className="required" /> 주소
            </th>
            <td>
              <div className="input-wrapper ">
                <div className="" tooltip="우편번호, 주소를 입력해주세요." flow="left" flag="hidden">
                  <span className="inquiry-group full">
                    <input
                      type="text"
                      id="splyaddr1"
                      title="우편번호"
                      name="splyaddr1"
                      className="form-keyword col1"
                      placeholder="우편번호"
                      readOnly
                      value={state?.['splyaddr1'] === 'null' ? '' : state?.['splyaddr1'] || ''}
                    />
                    <a
                      className="btn-secondary sm cursor"
                      onClick={(e) => {
                        e.preventDefault()
                        setState({ ...state, isSplyZipOpen: !state.isSplyZipOpen })
                        common.getDeviceType() === 'MobileApp' && window.scrollTo(0, 0)
                      }}
                    >
                      주소찾기
                    </a>
                    &nbsp;
                    <input
                      type="text"
                      id="splyaddr2"
                      title="주소"
                      name="splyaddr2"
                      className="form-keyword col2"
                      placeholder="주소"
                      readOnly
                      value={state?.['splyaddr2'] === 'null' ? '' : state?.['splyaddr2'] || ''}
                      style={{ width: 'inherit' }}
                    />
                  </span>
                  {nodeInfo.splyaddr1.errMessage && (
                    <div className="input-error">
                      <label htmlFor={'splyaddr1'} style={{ color: 'red' }}>
                        {nodeInfo.splyaddr1.errMessage}
                      </label>
                    </div>
                  )}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">상세주소</th>
            <td>
              {generateRow('splyaddr3')} {/* 상세주소 */}
            </td>
          </tr>
        </tbody>
      </table>
      <p className="ptxt1 mt30">※공급자에게 전자문서로 전달하는 경우 입력 (선택사항)</p>
      <table className="tbl-write">
        <caption>수발신인식별자, 상세수발신인식별자 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">수발신인식별자</th>
            <td>
              {generateRow('splycd')} {/* 수발신인식별자 */}
            </td>
          </tr>
          <tr>
            <th scope="row">상세수발신인식별자</th>
            <td>
              {generateRow('splyid')} {/* 상세수발신인식별자 */}
            </td>
          </tr>
        </tbody>
      </table>
      <table className="tbl-write mt20">
        <caption>이메일주소 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">이메일주소</th>
            <td>
              {generateRow('emlAddr')} {/* 이메일주소 */}
              <ul className="ulist1 mt5">
                <li>
                  구매확인서 발급사실을 공급자에게 신속히 메일로 알려드리기 위해 기재하는 사항이며, 구매확인서 서류가 전달되진 않습니다.
                </li>
                <li>수발신인식별자 기재시는 본 항목을 기재하실 필요는 없습니다.</li>
                <li>
                  <strong>
                    이메일주소를 잘못 기재하여 제3자에게 메일 전송 시, 그 책임은 구매확인 신청인에게 있습니다.
                    <br /> (문서복사 시 이메일정보를 다시 확인하시기 바랍니다)
                  </strong>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      <div className="btn-block">
        <a className="btn-secondary md cursor" onClick={props.doDelete}>
          취소
        </a>
        <span className="right">
          <a className="btn-primary md cursor" onClick={goStepNext}>
            다음
          </a>
        </span>
      </div>
      {state.isLctZipOpen === true && (
        <Zip
          isZipOpen={state.isLctZipOpen}
          onChange={() => setState({ ...state, isLctZipOpen: !state.isLctZipOpen })}
          onSelect={setLctAddress}
        />
      )}

      {state.isSplyZipOpen === true && (
        <Zip
          isZipOpen={state.isSplyZipOpen}
          onChange={() => setState({ ...state, isSplyZipOpen: !state.isSplyZipOpen })}
          onSelect={setSplyAddress}
        />
      )}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    stepData: state.certapply?.data?.step1,
    totalData: state.certapply.data,
    isCalled: state.certapply?.isCalled,
  }
}

const actionCreators = {
  saveStep1: certapplyActions.saveStep1,
  alert: certapplyActions.alert,
  setCalled: certapplyActions.setCalled,
}

export default connect(mapStateToProps, actionCreators)(Step01)
